export default "__VITE_ASSET__DhRPa8WN__"